module.exports = __webpack_public_path__ + "static/media/ageelementantiwrinkleeyecontour.13ff916a.png";